import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { colors, easing, radii, shadows } from "../../../theme";

const buttonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.95rem 1.7rem;
  border: 1.5px solid transparent;
  border-radius: ${radii.pill};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-color 0.3s ease, box-shadow 0.3s ease,
    transform 0.4s ${easing.out};

  svg {
    transition: transform 0.4s ${easing.out};
  }

  &:hover {
    transform: translateY(-2px);
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;

const buttonVariants = {
  primary: css`
    background-color: ${colors.primary};
    color: ${colors.secondary};

    &:hover {
      background-color: ${colors.buttonHover};
      box-shadow: ${shadows.honey};
    }
  `,
  ghost: css`
    background-color: rgba(255, 255, 255, 0.06);
    color: ${colors.backgroundMain};
    border-color: rgba(255, 255, 234, 0.5);
    backdrop-filter: blur(6px);

    &:hover {
      background-color: ${colors.backgroundMain};
      border-color: ${colors.backgroundMain};
      color: ${colors.secondary};
    }
  `,
};

export const ButtonLink = styled(Link)`
  ${buttonBase}
  ${({ $variant = "primary" }) => buttonVariants[$variant]}
`;

export const ArrowLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.25rem;
  font-weight: 600;
  color: ${colors.textMain};
  text-decoration: none;
  background-image: linear-gradient(${colors.primary}, ${colors.primary});
  background-size: 100% 2px;
  background-position: 0 100%;
  background-repeat: no-repeat;
  transition: color 0.3s ease, background-size 0.4s ${easing.out};

  svg {
    transition: transform 0.4s ${easing.out};
  }

  &:hover {
    color: ${colors.textSecondary};
    background-size: 40% 2px;
  }

  &:hover svg {
    transform: translateX(5px);
  }
`;
